__turbopack_context__.v({
  "actions": "WMFDtq_actions",
  "form": "WMFDtq_form",
  "hiddenFileInput": "WMFDtq_hiddenFileInput",
  "loadingActionsSkeleton": "WMFDtq_loadingActionsSkeleton",
  "loadingLogoRow": "WMFDtq_loadingLogoRow",
  "loadingSkeletons": "WMFDtq_loadingSkeletons",
  "loadingText": "WMFDtq_loadingText",
  "logoRow": "WMFDtq_logoRow",
  "readonlyField": "WMFDtq_readonlyField",
  "readonlyFields": "WMFDtq_readonlyFields",
  "workspaceSettingsPanel": "WMFDtq_workspaceSettingsPanel",
});
